import getApi from '../../api'
import { CodedInformationsGroupResponse } from '../../model/CodedInformations'

export const searchCodedInformationsGroup = (id: string) =>
  getApi().get<CodedInformationsGroupResponse>(`/coded_informations/group/${id}`)
